import React from 'react';

const InfiniteScrollTrigger = ({ 
  hasMore, 
  loadingMore, 
  totalVentas, 
  observerRef 
}) => {
  console.log('🎯 InfiniteScrollTrigger render:', {
    hasMore,
    loadingMore,
    totalVentas,
    hasRef: !!observerRef
  });

  if (!hasMore && totalVentas > 0) {
    return (
      <div className="flex justify-center py-8">
        <div className="bg-gray-50 rounded-xl p-6 border border-gray-200 text-center">
          <div className="text-gray-400 text-2xl mb-2">🏁</div>
          <p className="text-gray-600 font-medium">Has visto todas las ventas disponibles</p>
          <p className="text-gray-500 text-sm">Total: {totalVentas} ventas</p>
        </div>
      </div>
    );
  }

  if (!hasMore) return null;

  return (
    <div ref={observerRef} className="flex justify-center py-8">
      {loadingMore ? (
        <div className="flex items-center gap-3 bg-white rounded-xl shadow-lg p-6 border border-gray-200">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
          <span className="text-gray-600 font-medium">Cargando más ventas...</span>
        </div>
      ) : (
        <div className="bg-blue-50 rounded-xl p-4 border border-blue-200">
          <p className="text-blue-700 text-sm text-center">
            <span className="font-medium">📄</span> Desplázate hacia abajo para cargar más ventas
          </p>
        </div>
      )}
    </div>
  );
};

export default InfiniteScrollTrigger;
